import { useSyncExternalStore } from 'react';

/**
 * Subscribe to viewport width via `useSyncExternalStore` so reads stay reactive on
 * resize without a `setState`-in-effect. Concurrent-safe and SSR-safe.
 */
function subscribe(onChange: () => void): () => void {
  window.addEventListener('resize', onChange);
  return () => window.removeEventListener('resize', onChange);
}

const getSnapshot = (): number => window.innerWidth;

const getServerSnapshot = (): number => 0;

/**
 * Track `window.innerWidth` reactively.
 *
 * Used for layout that must animate between concrete pixel widths: CSS transitions
 * interpolate the raw `width` value, so a viewport-relative width (`calc`/`min`
 * with `vw`) can animate from an unexpected resolved value and visibly jump. A
 * plain px width derived from this hook transitions predictably.
 *
 * @returns the current viewport width in CSS pixels (0 during SSR).
 */
export function useViewportWidth(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
